// extracted by mini-css-extract-plugin
export var editor = "_1f-0";
export var flowSidebar = "_4o-2";